import React from "react";

const AdminConfig: React.FC = () => {


  return (
    <div className="env-page-container">
      <h2 className="env-page-title">Admin Configuration</h2>
      <section className="env-section">
        <div className="env-settings-card">
          <div className="env-settings-card-header">ADMIN TOOLS</div>
          <div style={{fontSize: 14, color: "#666", marginTop: 8}}>
            Admin configuration tools will be added here as needed.
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminConfig;
